import React from 'react';
// import { Counter } from './features/counter/Counter';
import './App.css';
import Header from './components/Header';
import Banner from './components/Banner';
import Content from './components/Content';
import Footer from './components/Footer';

function App() {
  return (
    <div className="app">
      <Header />
      <Banner />
      <Content />
      <Footer />
    </div>
  );
}

export default App;
